<template>
  <div class="relative right-0 h-full flex items-center justify-center bg-gray-100">
    <div class="text-center p-8">
      <h2 class="text-2xl font-bold mb-4">LinkedIn</h2>
      <p class="mb-6">Opening LinkedIn profile...</p>
      <a 
        :href="linkedInUrl" 
        target="_blank" 
        rel="noopener noreferrer"
        class="inline-block px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
      >
        Open LinkedIn Profile
      </a>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

const linkedInUrl = 'https://www.linkedin.com/in/sobhanizd/'

onMounted(() => {
  // Automatically open LinkedIn in a new tab
  window.open(linkedInUrl, '_blank', 'noopener,noreferrer')
})
</script>

